import React from 'react';
import { bannerImages } from '../data/mockData';

const BannerSection = ({ imageKey = 'banner1' }) => {
  return (
    <section className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <a
          href="https://www.amazon.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="block overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
        >
          <img
            src={bannerImages[imageKey]}
            alt="Health advertisement banner"
            className="w-full h-auto object-cover hover:scale-[1.02] transition-transform duration-500"
          />
        </a>
      </div>
    </section>
  );
};

export default BannerSection;
